module.exports = {
  platform: 'chat',
  name: 'Start',
  node: 'chat_start',
  bg: '#FFFFFF',
  note: '',
  property: {
    flow: {
      fallback_after: 1,
      fallback_timeout: 5,
      page_max_retry: '',
      page_time_out: '',
      page_error: '',
      data_not_available: 'Data not available'
    },
    tts: {
      voice: '',
      speed: 1,
      pitch: 1,
      dictionaries: [],
      dictionaries_name: []
    },
    default_input: {
      is_count_retry: true,
      nlu: ''
    },
    content: '${data_from_social}'
  }
}
